import React from 'react';
import UserService from '../Services/userService';
import ErrorMessage from './ErrorMessage';

class UserNameComponent extends React.Component {
  static defaultProps = {
    userId: null, //userId can be the real UserId or the GuidId, UserNameComponent will try to find the user by both
  };

  static askedValues = {};
  static refreshCallbacks = [];

  constructor(props) {
    super(props);
    this.state = {
      userName: '',
    };
    this.refresh = this.refresh.bind(this);
  }

  componentDidMount() {
    this.populateName();
  }

  componentDidUpdate(nextProps) {
    if (this.props.userId !== nextProps.userId) {
      this.populateName();
    }
  }

  componentWillUnmount() {
    const index = UserNameComponent.refreshCallbacks.indexOf(this.refresh);
    if (index > -1) {
      UserNameComponent.refreshCallbacks.splice(index, 1);
    }
  }

  populateName() {
    if (!this.props.userId) return null;
    if (UserNameComponent.askedValues[this.props.userId] === undefined) {
      UserNameComponent.askedValues[this.props.userId] = '';
      UserService.GetUserByGuidId(this.props.userId)
        .then((result) => {
          const name = result ? `${result.firstName} ${result.lastName}` : '-Error-';
          this.setState({ userName: name });
          UserNameComponent.askedValues[this.props.userId] = name;
          UserNameComponent.refreshCallbacks.forEach((f) => f());
        })
        .catch(() => ErrorMessage.SetErrorMessage('UNC61'));
    } else {
      this.setState({ userName: UserNameComponent.askedValues[this.props.userId] });
      UserNameComponent.refreshCallbacks.push(this.refresh);
    }
  }

  refresh() {
    this.setState({ userName: UserNameComponent.askedValues[this.props.userId] });
  }

  render() {
    return <div>{this.state.userName}</div>;
  }
}

export default UserNameComponent;
